import styled from 'styled-components';
import { Button } from 'antd';

export const StyledFormField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
`;

export const StyledForm = styled.div`
  border: 1px solid #cbced1;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;

  .ant-form-item {
    border-bottom: 1px solid #cbced1;
    margin-bottom: 10px;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
  }
`;

export const StyledCaption = styled.div`
  display: flex;
  font-size: 14px;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
`;

export const StyledFormLabel = styled.div`
  flex: 5;

  p {
    margin-bottom: 0;
  }

  span {
    font-size: 12px;
    color: #999;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const StyledKPIWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 10px;

  .kpi-delete-modal {
    position: absolute;
  }

  p {
    font-weight: 500;
  }
`;

export const StyledOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid #ccc;

  button {
    margin-left: 5px;
  }
`;

export const StyledSelect = styled.div`
  width: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .threshold-units {
    color: #999;
    width: 50px;
  }

  .threshold-condition {
    color: #999;
    text-align: center;
    width: 10px;
  }
`;

export const StyledName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  label {
    display: flex;
    width: 100px;
  }
`;

export const StyledTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 30px;
`;

export const StyledAnd = styled.div`
  flex: 1;
  color: #999;
`;

export const StyledAddButton = styled(Button)`
  background-color: #f2f6ff;
  border-radius: 0;
  border: none;
  color: #0046ff;
`;

export const StyledGoBackButton = styled(Button)`
  background-color: #f2f6ff;
  border-radius: 0;
  border: none;
  color: #0046ff;
`;

export const StyledDeleteButton = styled(Button)`
  background-color: #fff1f0;
  border-radius: 0;
  border: none;
  color: #ff4d4f;
  padding: 0 7px;

  &:hover {
    color: #ff4d4f !important;
  }

  &:disabled {
    background-color: #eee !important;
    color: #aaa !important;
  }
`;

export const StyledEditButton = styled(Button)`
  background-color: #f2f6ff;
  border-radius: 0;
  border: none;
  color: #0046ff;
  margin: 0 10px;
  padding: 0 7px;

  &:hover {
    color: #0046ff;
  }

  &:disabled {
    background-color: #eee !important;
    color: #aaa;
  }
`;

export const StyledSwitch = styled.div`
  width: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 30px;
`;
